import { UseCaseError } from '@digibricks/core';

export class CodedResultError<T = unknown> extends UseCaseError<T> {
  constructor(
    message?: string | Error,
    public readonly code?: string,
  ) {
    super(message);
  }
}

export const getResultErrorCode = (error: unknown): string | undefined =>
  error instanceof CodedResultError ? error.code : undefined;
